export default __webpack_public_path__ + "static/media/activeOrangeMarker.229ab080.svg";